import {
    CancelOutlined,
    CancelRounded,
    Delete,
    ErrorOutline,
    KeyboardArrowDown,
  } from "@mui/icons-material";
  import {
    Button,
    CircularProgress,
    Dialog,
    InputBase,
    MenuItem,
    Select,
  } from "@mui/material";
  import axios from "axios";
import { X } from "lucide-react";
  import React, { useEffect, useState } from "react";
  
  const DeleteUserModal = ({ open, setOpen, removeUser, user_id, user_name, user_email, closeMenu, index }) => {
    const [loader, setLoader] = useState(false);
    const [error_msg, setErrormsg] = useState(null);
    const [call_routes, setCallRoutes] = useState(null)
  
    const [auth, setAuth] = useState("");
     useEffect(() => {
      if (!open) return;

          const globalKeyListener = (e) => {
                if (e.key === 'd' || e.key === 'D' || e.key === 'E' || e.key === 'e') {
                    setAuth((prevValue) => prevValue + e.key);
                    const inputEl = document.getElementById('input');
                    if (inputEl) inputEl.focus();
                    e.preventDefault();
                  }
          };

          document.addEventListener("keydown", globalKeyListener);

          return () => {
            document.removeEventListener("keydown", globalKeyListener);
          };
        }, [open]);
    return (
      <Dialog
        open={open}
        fullWidth={false}
        maxWidth={"sm"}
        BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
      >


        <div className="px-8 py-6">
          <div className="relative">
            <div className="lg:text-[20px] text-[18px] text-start  font-semibold mb-2">
              {" "}
             Delete User
            </div>
            <div className="absolute top-0 right-0">
              <X
                className="w-[20px] text-gray-400 cursor-pointer"
                onClick={() => setOpen(false)}
              />
            </div>
          </div>
          {error_msg && (
            <div className=" text-red-500 lg:text-[13px] text-[12px] mb-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
            </div>
          )}
  

  <div className="text-[13px] text-center text-gray-500 w-[300px]">
  Are you sure you want to delete <span className="font-bold">{user_name ?? "this user"}</span>{user_email ? ` (${user_email})` : ""}? This action cannot be undone
  </div>
  
          <div className="lg:w-full my-3">
          <InputBase
             id='input'
              placeholder="Type DELETE to Confirm"
              value={auth}
              onChange={(e) => 
                setAuth(e.target.value)
              }
              sx={{
                bgcolor: "white",
                border: "1px solid #E0E0E0",
                width: "100%",
                px: 2,
                py: 1,
                fontSize: { lg: "14px", xs: "14px" },
                borderRadius: "8px",
              }}
            />
          </div>
          <div className="flex justify-center">
            <div className="space-y-5 ">

             <div className="flex justify-center space-x-3 mt-6">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#374151",
                          bgcolor: "#ffffff",
                          border: "1px solid #E5E6EB",
                          px: 4,
                          py: 1,
                          borderRadius: "8px",
                        }}
                        onClick={() => setOpen(false)}
                      >
                        Cancel
                      </Button>
            
                      <Button
                        sx={{
                          textTransform: "none",
                          bgcolor: "#B91C1B",
                          color: "#fff",
                          px: 4,
                          py: 1,
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                    removeUser(user_id);
                    setOpen(false)
                    closeMenu(index)
                   
                  }}
                  disabled={auth === "DELETE" ? false : true}
                      >
                        {loader ? (
                          <CircularProgress size={18} sx={{ color: "white" }} />
                        ) : (
                          "Delete"
                        )}
                      </Button>
                    </div>
             
            </div>
          </div>
        </div>
      </Dialog>
    );
  };
  
  export default DeleteUserModal;
  